<h4>Widget Types</h4>
<p>Choose a widget type to begin editting</p>

<mat-grid-list cols="3" rowHeight="150px" [gutterSize]="'10px'">

  <mat-grid-tile [style.background-color]="widget?.widgetType == widgetTypes.image ? '#00abca' : '#ededed'">
    <button class="widget-type-button" (click)="widget.widgetType = widgetTypes.image">
      <div>
        <div>
          <mat-icon class="mat-icon-widget-type-button">image</mat-icon>
        </div>
        <p style="margin-top:0;">Image Widget</p>
      </div>
    </button>
  </mat-grid-tile>

  <mat-grid-tile [style.background-color]="widget?.widgetType == widgetTypes.text ? '#00abca' : '#ededed'">
    <button class="widget-type-button" (click)="widget.widgetType = widgetTypes.text">
      <div>
        <div>
          <mat-icon class="mat-icon-widget-type-button">text_format</mat-icon>
        </div>
        <p style="margin-top:0;">Text Widget</p>
      </div>
    </button>
  </mat-grid-tile>

  <mat-grid-tile [style.background-color]="widget?.widgetType == widgetTypes.barChart ? '#00abca' : '#ededed'">
    <button class="widget-type-button" (click)="widget.widgetType = widgetTypes.barChart">
      <div>
        <div>
          <mat-icon class="mat-icon-widget-type-button">bar_chart</mat-icon>
        </div>
        <p style="margin-top:0;">Bar Chart Widget</p>
      </div>
    </button>
  </mat-grid-tile>

  <mat-grid-tile [style.background-color]="widget?.widgetType == widgetTypes.lineChart ? '#00abca' : '#ededed'">
    <button class="widget-type-button" (click)="widget.widgetType = widgetTypes.lineChart">
      <div>
        <div>
          <mat-icon class="mat-icon-widget-type-button">stacked_line_chart</mat-icon>
        </div>
        <p style="margin-top:0;">Line Chart Widget</p>
      </div>
    </button>
  </mat-grid-tile>

  <mat-grid-tile [style.background-color]="widget?.widgetType == widgetTypes.pieChart ? '#00abca' : '#ededed'">
    <button class="widget-type-button" (click)="widget.widgetType = widgetTypes.pieChart">
      <div>
        <div>
          <mat-icon class="mat-icon-widget-type-button">pie_chart</mat-icon>
        </div>
        <p style="margin-top:0;">Pie Chart Widget</p>
      </div>
    </button>
  </mat-grid-tile>

  <mat-grid-tile [style.background-color]="widget?.widgetType == widgetTypes.fuelGauge ? '#00abca' : '#ededed'">
    <button class="widget-type-button" (click)="widget.widgetType = widgetTypes.fuelGauge">
      <div>
        <div>
          <mat-icon class="mat-icon-widget-type-button">speed</mat-icon>
        </div>
        <p style="margin-top:0;">Fuel Gauge Widget</p>
      </div>
    </button>
  </mat-grid-tile>
</mat-grid-list>


